import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'panelComponents/Panel';
import DeliveryProofComponent from "./DeliveryProofComponent";
import DeliveryProofCloseStep from "./DeliveryProofCloseStep";


const DeliveryProofPanel = (props) => {
  const {
    style,
    paddingLeft,
    paddingRight,
    orderId,
    detailKey,
    header,
    orderCloseDetails,
    workOrderActions,
    customerDetail
  } = props;

  return (
    <Panel
      style={style}
      paddingLeft={paddingLeft}
      paddingRight={paddingRight}
      loading={false}
      hasDetails={true}
      orderId={orderId}
      detailKey={detailKey}
      header={header}
    >
      <DeliveryProofComponent
        workOrderActions={workOrderActions}
        orderCloseDetails={orderCloseDetails}
        orderId={orderId}
        customerDetail={customerDetail}
      />
    </Panel>
  );
};


DeliveryProofPanel.propTypes = {
    paddingLeft: PropTypes.number,
    paddingRight: PropTypes.number,
    header: PropTypes.object,
    style: PropTypes.object,
    detailKey: PropTypes.string,
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    customerDetail: PropTypes.object,
};

export default DeliveryProofPanel;



// WEBPACK FOOTER //
// ./src/components/delivery-proof/DeliveryProofPanel.js